@if(optionsValue().showButtonVisible)
{
    <div>
        <button type="button" (click)="show()" [ngClass]="optionsValue().cssClasses.btnElement">
            <span [ngClass]="optionsValue().cssClasses.btnIconElement"></span>
            <span>{{optionsValue().texts.btnShowSelection | localize}}</span>
        </button>
    </div>
}